module.exports = __webpack_public_path__ + "img/08.c1e3a9bc.jpg";